import { TopicQuestionFeedback, LessonQuestionFeedback } from "shared/types/submissionTypes"

export const isLessonQuestionFeedback = (response: TopicQuestionFeedback | LessonQuestionFeedback): response is LessonQuestionFeedback => {
    return !!response && "questionNumber" in response && "sectionNumber" in response
}

export const isTopicQuestionFeedback = (response: TopicQuestionFeedback | LessonQuestionFeedback): response is TopicQuestionFeedback => {
    return !!response && "topicQuestionId" in response
}
